import { PageContext } from '../../services/build/types';
import { PageContent } from '../types';

export const pageContent = (data: PageContext): PageContent => {
  const { story } = data;

  const storyTags = story?.content?.tag ?? [];

  const contentTags = storyTags.map((tag: string) => ({
    id: '',
    name: tag,
  }));

  return {
    vvpm: [],
    indication: [],
    therapeuticArea: [],
    product: [],
    contentTags,
    contentHashtags: [],
    contentDuration: '',
    course: {},
  };
};
